import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/departmentsmanagers/';
    const pathsList = {
        pathAdd: pathFrontEnd+'add',
        pathEdit: pathFrontEnd+'edit',
        pathView: pathFrontEnd+'view',
        endpoint: config.endpoints.backend+'governanceroom/departmentsmanagers/getall',
        endpointDelete: `${config.endpoints.backend}governanceroom/departmentsmanagers/delete`
    }
    
    const list = {
        labelTitle: 'Lista de Gestores de Departamentos',
        labelTitleButtonAdd: 'Incluir novo gestor de departamento',
        fieldsShowOnDelete: ['name'],
        canDelete: true,
        filter:{
            ...profileFilter
        },
        columns: [
            {
                name: 'department_manager_name',
                label: 'Nome'
            },            
            {
                name: 'city_name',
                label: 'Município'
            },
            {
                name: 'title_secretariat',
                label: 'Secretaria'
            },
            {
                name: 'city_name',
                label: 'Município'
            },
            {
                name: 'title_department',
                label: 'Departamento'
            },
            {
                name: 'status_name',
                label: 'Status'
            }
        ],  
        ...pathsList 
    };    

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
